<template>
    <div>
        <el-dialog title="设备租赁合同" :visible.sync="jcxy" :close-on-click-modal="false" width="1000px" center>
            <el-form :inline="true">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务者">
                            <el-select v-model="reqCreate.personId" @change="selectPerson" filterable clearable collapse-tags>
                                <el-option v-for="(item, key) in singList" :key="key" :label="item.workerName+item.workerTel" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名（乙方）">
                            <el-input v-model="reqCreate.name" style="width:220px" clearable show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="电话">
                            <el-input v-model="reqCreate.tel" style="width:233px" clearable maxlength="11" show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号码">
                            <el-input v-model="reqCreate.idCard" style="width:233px" clearable maxlength="18" show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="联系地址">
                            <el-input v-model="reqCreate.address" style="width:670px" show-word-limit placeholder clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-table :data="goodsList" border style="width: 100%" class="table">
                        <el-table-column prop="goodsName" label="(设备/工具)名称"></el-table-column>
                        <el-table-column prop="remark" width="130px" label="设备 市场价/租金"></el-table-column>

                        <el-table-column prop="snCode" width="250px" label="设备编码">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.type==1" v-model="scope.row.snCode" style="width:100%" clearable show-word-limit placeholder></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" label="数量">
                            <template slot-scope="scope">
                                <el-input type="number" @input.native="mynumber($event)" v-model="scope.row.number" style="width:100%" clearable show-word-limit placeholder></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="receiveDate" label="领用时间">
                            <template slot-scope="scope">
                                <el-date-picker v-if="scope.row.type==2" v-model="scope.row.receiveDate" style="width:140px" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br />
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="" style="color:red;">
                            本合同设备租金为人民币（√选）：
                            <el-radio-group v-model="reqCreate.zj">
                                <el-radio :label="200">200元/月</el-radio>
                                <el-radio :label="100">100元/月</el-radio>
                            </el-radio-group>

                            <br />租金按1个月为一期支付，每期租金为人民币（√选）：
                            <el-radio-group v-model="reqCreate.mq">
                                <el-radio :label="200">200元/月</el-radio>
                                <el-radio :label="100">100元/月</el-radio>
                            </el-radio-group>
                            ,租期少于15日的，按照半个月计算，多于15日的，
                            <br />按照1个月计算。租期/租金 共计：

                            <el-radio-group v-model="reqCreate.leaseDurationChoose">
                                <el-radio :label="20">共 20期； ¥4000元</el-radio>
                                <el-radio :label="-1">
                                    <el-input type="number" @input.native="mynumber($event)" :readonly="reqCreate.leaseDurationChoose==20" v-model="reqCreate.leaseDuration" style="width:130px" clearable show-word-limit placeholder></el-input>期；
                                    ¥<el-input type="number" @input.native="mynumber($event)" :readonly="reqCreate.leaseDurationChoose==20" v-model="reqCreate.leaseRent" style="width:130px" clearable show-word-limit placeholder></el-input>元
                                </el-radio>
                                <el-radio :label="-2">
                                    无固定租期,¥ 累计租金
                                </el-radio>
                            </el-radio-group>
                            <br/>
                        本人同意上海宅易丞网络科技有限公司从本人当月服务费中按月扣除设备月租金
                        <el-radio-group v-model="reqCreate.kouchu">
                                <el-radio :label="200"> 200元/月</el-radio>
                                <el-radio :label="100"> 100元/月</el-radio>
                        </el-radio-group>
                        

                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="租赁期限">
                            <el-date-picker v-model="reqCreate.dateStart" style="width:140px" type="datetime" placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                            至 <el-date-picker v-model="reqCreate.dateEnd" style="width:140px" type="datetime" placeholder="截止日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="合同日期" prop="data1">
                            <el-date-picker v-model="reqCreate.qsrq" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy=false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0" style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import globalData from "@/components/common/globaldata/global.data";
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,

            field107: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            goodsList: [
                {
                    goodsName: '卡赫凯驰SG4/2蒸汽机(新设备含配件)',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 1,
                    priceDesc: '200',
                    remark: '市场价6000元,租金200每月'
                },
                {
                    goodsName: '卡赫凯驰SG4/2蒸汽机(旧设备含配件)',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 1,
                    priceDesc: '200',
                    remark: '实际价值按6000元20个月折旧计算，租金200每月'
                },
                {
                    goodsName: '卡赫凯驰SC5蒸汽机(含设备配件)',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 1,
                    priceDesc: '100',
                    remark: '市场价3000元,租金100每月'
                },
                {
                    goodsName: '专项拉杆箱',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 2,
                    priceDesc: '450',
                    remark: '市场价450元'
                },
                { goodsName: '伸缩梯', snCode: null, number: null, receiveDate: null, type: 2, priceDesc: '400', remark: '市场价400元' },
                {
                    goodsName: '卡赫凯驰DS6000除螨仪',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 2,
                    priceDesc: '3500',
                    remark: '市场价3500元'
                },
                {
                    goodsName: '干湿两用桶式吸尘器',
                    snCode: null,
                    number: null,
                    receiveDate: null,
                    type: 2,
                    priceDesc: '550',
                    remark: '市场价550元'
                }
            ],

            reqCreate: {
                personId: null,
                qsrq: null,

                
                workerNo:null,
                cityId:null,
                name: null,
                tel: null,
                idCard: null,
                address: null,
                dateStart: null,
                dateEnd: null,

                zj: 200, //租金200，100
                mq: 200, //每期租金为人民币200，100

                leaseDurationChoose: 20, //选择租赁20期  -1输入,-2长期
                leaseDuration: null,
                leaseRent: null,

                kouchu:200,

                tempSignData: {},
                fraId: null,
                operId: null,
                operName: null,

                contractFileId: null,
                templateNo: null,
                contractNo: null,
                contractType: null
            }
        };
    },
    methods: {
        showDetail() {
            this.jcxy = true;

            this.reqCreate = {
                personId: null,
                qsrq: null,

                cityId:null,
                workerNo:null,
                name: null,
                tel: null,
                idCard: null,
                address: null,
                dateStart: null,
                dateEnd: null,

                zj: 200, //租金200，100
                mq: 200, //每期租金为人民币200，100

                leaseDurationChoose: 20, //选择租赁20期  -1输入
                leaseDuration: null,
                leaseRent: null,

                kouchu:200,

                tempSignData: {},
                fraId: null,
                operId: null,
                operName: null,

                contractFileId: null,
                templateNo: null,
                contractNo: null,
                contractType: null
            };

            this.loadSingList();
        },
        loadSingList() {
            contract.$ajaxGetAllWorkerList({fraId:293}).then((res) => {
                if (res.data.errno == 0) {
                    this.singList = res.data.data;
                }
            });
        },
        selectPerson(id) {
            if (id == null || id == '') {
                this.reqCreate.name = '';
                this.reqCreate.tel = '';
                this.reqCreate.idCard = '';
            }
            let that = this;
            this.singList.forEach((e) => {
                if (e.id == id) {
                    that.choosePerson = e;
                }
            });
            if (id != null) {
                this.reqCreate.name = this.choosePerson.workerName;
                this.reqCreate.workerNo= this.choosePerson.workerNo;
                this.reqCreate.tel = this.choosePerson.workerTel;
                this.reqCreate.idCard = this.choosePerson.idCrad;
            }
        },
        checkFm() {
            if (this.reqCreate.name == null || this.reqCreate.name == '') {
                this.$message.error('请选择服务者，或输入姓名');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请选择服务者，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.idCard == null || this.reqCreate.idCard == '' || this.reqCreate.idCard.length != 18) {
                this.$message.error('请选择服务者，或输入正确的身份证');
                return false;
            }
            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入联系地址');
                return false;
            }

            //校验表格项
            let zl = false;
            for (let i = 0; i < this.goodsList.length; i++) {
                let e = this.goodsList[i];

                if (e.number != null && e.number != '') {
                    zl = true; //至少一个数量
                    if (e.type == 1 && (e.snCode == null || e.snCode == '')) {
                        this.$message.error('请选择设备编码：' + e.goodsName);
                        return false;
                    }
                    if (e.type == 2 && (e.receiveDate == null || e.receiveDate == '')) {
                        this.$message.error('请选择领用时间：' + e.goodsName);
                        return false;
                    }
                }
            }
            if (!zl) {
                this.$message.error('至少租赁一个商品或工具，请填写对应数量');
                return false;
            }

            //校验选择的项  -1是手输
            if (this.reqCreate.leaseDurationChoose == -1) {
                if (this.reqCreate.leaseDuration == null || this.reqCreate.leaseDuration == '') {
                    this.$message.error('请输入总租期');
                    return false;
                }
                if (this.reqCreate.leaseRent == null || this.reqCreate.leaseRent == '') {
                    this.$message.error('请输入租总金额');
                    return false;
                }
            }
            if (this.reqCreate.leaseDurationChoose == 20) {
                this.reqCreate.leaseDuration = 20;
                this.reqCreate.leaseRent = 3600;
            }
             if (this.reqCreate.leaseDurationChoose == -1) {//手输入
                 this.reqCreate.leaseDuration = this.reqCreate.leaseDuration;
                this.reqCreate.leaseRent = this.reqCreate.leaseRent;
            }

            if (this.reqCreate.leaseDurationChoose == -2) {//长期
                this.reqCreate.leaseDuration = 0;
                this.reqCreate.leaseRent = 0;
            }

            //租赁期限
            if (this.reqCreate.dateStart == null || this.reqCreate.dateStart == '') {
                this.$message.error('请选择租赁期限开始日期');
                return false;
            }

            if (this.reqCreate.dateEnd == null || this.reqCreate.dateEnd == '') {
                this.$message.error('请选择租赁期限截止日期');
                return false;
            }

            if (this.reqCreate.qsrq == null || this.reqCreate.qsrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            
            let field107 = {
                // Contract_no: null,
                name: this.reqCreate.name,
                id_card: this.reqCreate.idCard,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,

                kaichi_sg4_2_new: this.goodsList[0].snCode,
                kaichi_sg4_2_old: this.goodsList[1].snCode,
                kaichi_sg5: this.goodsList[2].snCode,

                number: this.goodsList[0].number,
                number2: this.goodsList[1].number,
                number3: this.goodsList[2].number,
                number21: this.goodsList[3].number,
                number4: this.goodsList[4].number,
                number22: this.goodsList[5].number,
                number23: this.goodsList[6].number,

                receive_time21: this.goodsList[3].receiveDate,
                receive_time22: this.goodsList[4].receiveDate,
                receive_time23: this.goodsList[5].receiveDate,
                receive_time24: this.goodsList[6].receiveDate,

                year_start: this.reqCreate.dateStart.substring(0, 4),
                month_start: this.reqCreate.dateStart.substring(5, 7) * 1,
                day_start: this.reqCreate.dateStart.substring(8, 10) * 1,
                year_end: this.reqCreate.dateEnd.substring(0, 4),
                month_end: this.reqCreate.dateEnd.substring(5, 7) * 1,
                day_end: this.reqCreate.dateEnd.substring(8, 10) * 1,

                zj200: this.reqCreate.zj == '200' ? '√' : '/',
                zj100: this.reqCreate.zj == '100' ? '√' : '/',
                mq200: this.reqCreate.mq == '200' ? '√' : '/',
                mq100: this.reqCreate.mq == '100' ? '√' : '/',

                qi18: this.reqCreate.leaseDurationChoose == '20' ? '√' : '/',
                qi_other: this.reqCreate.leaseDurationChoose == '-1' ? this.reqCreate.leaseDuration : '/',

                yuan3600: this.reqCreate.leaseDurationChoose == '20' ? '√' : '/',
                yuan_other: this.reqCreate.leaseDurationChoose == '-1' ? '√' : '/',

                yuan_other_number: this.reqCreate.leaseDurationChoose == '-1' ? this.reqCreate.leaseRent : '/',
                qitaqi: this.reqCreate.leaseDurationChoose == '-1' ? '√' : '/',

                wuguding: this.reqCreate.leaseDurationChoose == '-2' ? '√' : '/',
                wuguding2: this.reqCreate.leaseDurationChoose == '-2' ? '√' : '/',

                sqdb: '王松青',
                gsdz: '上海市浦东新区祖冲之路1505弄100号3幢5楼',
                qsrq2: this.reqCreate.qsrq,
                // gz: null,
                yifang_2: this.reqCreate.name,
                tel_2: this.reqCreate.tel,
                address2: this.reqCreate.address,
                qsrq: this.reqCreate.qsrq,

                cnr: this.reqCreate.name,
                yyyy: this.reqCreate.qsrq.substring(0, 4) * 1,
                mm: this.reqCreate.qsrq.substring(5, 7) * 1,
                dd: this.reqCreate.qsrq.substring(8, 10) * 1,
                kouchu: this.reqCreate.kouchu,
                // gz2: null
            };

            this.field107 = field107;
            return field107;
        },
        yulan() {
            if (!this.checkFm()) {
                return;
            }
            let temFields = this.fillTemplate();
            this.reqCreate.tempSignData = temFields;

            let reqData = {
                // cityId: 1,
                fraId : this.choosePerson.fraId,
                eventType: 107, //设备租赁合同
                name: '设备租赁合同',
                simpleFormFields: temFields
            };

            const loading = this.$loading({
                lock: true,
                text: '努力生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            contract
                .$ajaxPreviewFile(reqData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        loading.close();
                        // console.log(res);
                        this.contractUrl = res.data.data.downloadUrl;
                        this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                        this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                        this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                        this.PDFVisible = true;
                    } else {
                        loading.close();
                        this.$message({
                            showClose: true,
                            message: res.data.data,
                            type: 'warning',
                            duration: 8000
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.operId = globalData.userInfo.id;
            this.reqCreate.operName = globalData.userInfo.userName;

            // this.reqCreate.name = this.choosePerson.name;
            // this.reqCreate.idCard = this.choosePerson.idCard;
            // this.reqCreate.address = this.choosePerson.address;
            // this.reqCreate.tel = this.choosePerson.tel;

            this.reqCreate.contractType = 107;
            this.reqCreate.goodsList = this.goodsList;

            contract.$ajaxWorkerContractSignTerminated(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同发送成功！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        mynumber(e) {
            let _value = e.target.value; // 获取到输入框的value值
            const reg = isNaN(_value); // 判断拿到的value是否为数字
            if (reg) {
                // 若为非数字键，则全部替换为空
                e.target.value = _value.replace(/[^1-9]/g, '');
            }
            if (_value === '0') {
                // 若为0，则替换为空
                e.target.value = _value.replace(/^[^1-9]/g, '');
            }
        }
    }
};
</script>
<style lang="">
</style>